// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"441":"db66e0c7","488":"dbceb239","749":"523dc9d1","787":"aca2e8fb","902":"eb310e33","940":"6b02103c"}[chunkId] + ".chunk.js";
};